import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'dtUserCode',
    detailIdProp: 'dtId',
    detailUrl: '/DtDetail',
    listUrl: '/DtList',
    mapProp: 'dtMap',
    name: '数据表',
    textProp: 'dtName',
    type: 'DT',
}
